module.exports = __webpack_public_path__ + "public/SiteImages/fullimage2.jpg?ce344b31";